import { render, staticRenderFns } from "./Oglasi.vue?vue&type=template&id=ba218a24&scoped=true"
import script from "./Oglasi.vue?vue&type=script&lang=js"
export * from "./Oglasi.vue?vue&type=script&lang=js"
import style0 from "./Oglasi.vue?vue&type=style&index=0&id=ba218a24&prod&lang=scss&scoped=true"
import style1 from "./Oglasi.vue?vue&type=style&index=1&id=ba218a24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba218a24",
  null
  
)

export default component.exports